import { Button, Col, Form, Row, Space, theme, Table, DatePicker, Select, message } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import dayjs from 'dayjs';
import { filterOption, filterShopsByUser } from '../../utils/funcHelper';
import { HeaderTableCus, requiredItem } from '../../constants/constants';
import { exportOrdersBySeller, filterOrdersBySeller, getListAccount, getListShops, getOrdersReport } from '../../services/apis';
import { useSelector } from 'react-redux';
import { ExportOutlined, SearchOutlined } from '@ant-design/icons';

const ReportOrderByShop = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { RangePicker } = DatePicker;
    const [dataSellers, setDataSellers] = useState([]);
    const columns = [
        {
            title: "Seller",
            dataIndex: "seller_name",
            key: "seller_name",
            width: 150,
            align: "center",
            onCell: (record) => ({
                rowSpan: record.group_size_seller, // merge theo seller
            }),
            render: (text) => <b>{text}</b>,
        },
        {
            title: "Shop",
            dataIndex: "shop_display_name",
            key: "shop_display_name",
            width: 200,
            align: "center",
            onCell: (record) => ({
                rowSpan: record.group_size_shop, // merge theo shop
            }),
            render: (text) => <span style={{ color: "#1677ff", paddingLeft: 8, paddingRight: 8 }}>{text}</span>,
        },
        {
            title: "Order ID",
            dataIndex: "order_id",
            key: "order_id",
            align: "center",
            width: 160,
            render: (text) => <span >{text}</span>,
        },
        {
            title: "Product",
            dataIndex: "product_name",
            key: "product_name",
            width: 250,
            render: (text) => <span style={{ paddingLeft: 8 }}>{text}</span>,
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
            width: 100,
            render: (val) => <b>{val}</b>,
        },
        {
            title: "Earnings",
            dataIndex: "est_settlement_amount",
            key: "est_settlement_amount",
            align: "center",
            width: 100,
            render: (val) => <div style={{textAlign: 'right', paddingRight: 8}}><b>{val}</b></div>,
        },
        {
            title: "Image",
            dataIndex: "sku_image",
            key: "sku_image",
            width: 100,
            align: "center",
            render: (url) =>
                url ? (
                    <img
                        src={url}
                        alt="SKU"
                        width={60}
                        height={60}
                        style={{
                            objectFit: "cover",
                            borderRadius: 8,
                            boxShadow: "0 0 4px rgba(0,0,0,0.15)",
                        }}
                    />
                ) : (
                    "-"
                ),
        },
        {
            title: "Customer note",
            dataIndex: "buyer_message",
            key: "buyer_message",
            align: "center",
            width: 100,
            render: (val) => <div style={{textAlign: 'left', paddingLeft: 8}}>{val}</div>,
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const getDataReport = async (startTime, endTime) => {
        const params = {
            from_date: startTime,
            to_date: endTime,
            seller_id: form.getFieldValue('seller_id') || null,
        }
        setLoading(true);
        const res = await filterOrdersBySeller(params);
        consoleLogUtil('getDataReport', res);
        setLoading(false);
        if (res && res.status === 1) {
            setData([...res?.data || []]);
        } else {
            setData([]);
        }
    }
    const getDataSellers = async () => {
        try {
            const params = {
                keyword: '',
                department_id: 5,
                limit: 100,
                currentPage: 1,
            }
            setLoading(true);
            const res = await getListAccount(params);
            setLoading(false);
            if (res && res.status === 1) {
                setDataSellers([...res?.data?.data?.map(item => ({
                    ...item,
                    label: item.fullname,
                    value: item.id,
                }))]);
            } else {
                setDataSellers([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const handleExportExcel = async () => {
        if (!form.getFieldValue('date')) {
            message.error('Vui lòng chọn khoảng thời gian xuất excel');
            return;
        }
        const params = {
            from_date: dayjs(form.getFieldValue('date')[0]).format("YYYY-MM-DD HH:mm:ss"),
            to_date: dayjs(form.getFieldValue('date')[1]).format("YYYY-MM-DD HH:mm:ss"),
            seller_id: form.getFieldValue('seller_id') || null,
        }
        setLoading(true);
        const res = await exportOrdersBySeller(params);
        consoleLogUtil('exportOrdersBySeller', res);
        setLoading(false);
        if (res && res.status === 1) {
            message.success('Xuất excel thành công');
            window.open(res?.data?.download_link, '_blank');
        } else {
            message.error(res?.msg || 'Xuất excel thất bại');
        }
    }

    const onFinish = async (dataForm) => {
        if (dataForm && dataForm?.date) {
            getDataReport(dayjs(dataForm.date[0]).format("YYYY-MM-DD HH:mm:ss"), dayjs(dataForm.date[1]).format("YYYY-MM-DD HH:mm:ss"))
        } else {
            getDataReport(dayjs().format("YYYY-MM-DD") + "00:00:00", dayjs().format("YYYY-MM-DD HH:mm:ss"))
        }
    };


    useEffect(() => {
        getDataSellers(true);
    }, []);
    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name={'seller_id'}
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn  seller'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataSellers}
                                maxTagCount={'responsive'}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            name={'date'}
                            rules={requiredItem}
                        >
                            <RangePicker
                                style={{ height: 40, width: '100%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                showTime
                                allowClear={false}
                            />
                        </Form.Item>
                    </Col>


                    <Col span={2}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                                Tìm kiếm
                            </Button>
                            <Button danger icon={<ExportOutlined />}
                                onClick={() => handleExportExcel()}
                            >
                                Xuất excel
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                className='table-book'
                columns={columns}
                components={HeaderTableCus}
                dataSource={data}
                pagination={
                    {
                        pageSize: 100,
                        showSizeChanger: true,
                        pageSizeOptions: ['50', '100', '200', '500'],
                    }
                }
                bordered
                rowKey={(record) => record?.id}
                scroll={{ x: 'max-content', y: 600 }}
            />

            <LoadingBase loading={loading} />

        </div>
    )
}
export default React.memo(ReportOrderByShop);